import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { PublicationProductModel } from '@domain-group/realhub-backend-api-types'

interface PublicationProductProps {
  onClick: () => void,
  entity: PublicationProductModel,
  selected: boolean,
}

const PublicationProduct = (props: PublicationProductProps) => {
  const {
    entity: { id, title },
    onClick,
    selected,
  } = props

  return (

    <DashboardModuleListItem
      isChecked={selected}
      onClick={onClick}
      showCheckbox
      title={title}
    >
      <Text color="bodyFontLightColor">ID #{id}</Text>
    </DashboardModuleListItem>

  )
}

export default PublicationProduct
